module.exports = __webpack_public_path__ + "img/epr_small@2x.9b4b2418.webp";